module.exports = __webpack_public_path__ + "img/A_pointname.7a51b6f5.png";